import Quill from "quill";

const QuillScroll = Quill.import("blots/scroll");

export class Scroll extends QuillScroll {}

Scroll.events = {
  BLOT_MOUNT: "blot:mount",
  BLOT_UNMOUNT: "blot:unmount"
};
